import React from 'react';
import { CheckboxContained, CheckboxContainedGroup } from '@homeexchange/design';
import Filters from '../../../../models/Filters';
import i18n from '../../../../i18n';
import Screen from '../../../../utils/Screen';
import { getCheckboxStatus } from '../utils';
export var ResidenceType = function (_a) {
    var inputValue = _a.inputValue, onChange = _a.onChange;
    return (React.createElement(CheckboxContainedGroup, { buttonWithDescription: Screen.isTabletOrUpper() },
        React.createElement(CheckboxContained, { key: Filters.IS_PRIMARY.primary, label: i18n.t('search:filter.primary'), onChange: onChange, name: Filters.IS_PRIMARY.name, checked: getCheckboxStatus(inputValue, Filters.IS_PRIMARY.primary), value: "true" }),
        React.createElement(CheckboxContained, { key: Filters.IS_PRIMARY.secondary, label: i18n.t('search:filter.secondary'), onChange: onChange, name: Filters.IS_PRIMARY.name, checked: getCheckboxStatus(inputValue, Filters.IS_PRIMARY.secondary), value: "false" })));
};
